import api from './api';
import authHeader from './auth-header';

class WorkplaceService {
    getWorkplaces() {
        return api.get('/workplaces', { headers: authHeader() });
    }

    createWorkplace(name) {
        return api.post('/workplaces', { name }, { headers: authHeader() });
    }

    updateWorkplace(id, data) {
        return api.put(`/workplaces/${id}`, data, { headers: authHeader() });
    }

    deleteWorkplace(id) {
        return api.delete(`/workplaces/${id}`, { headers: authHeader() });
    }
}

const workplaceService = new WorkplaceService();
export default workplaceService; 